import { schoolsSlice } from "./slice";

export const {
  setSelectedSession,
  resetSchoolSlice,
  setSessionMonth,
  updateUpcomingDueDate,
} = schoolsSlice.actions;
